<template>
  <el-card class="h-full" :body-style="{ height: '100%' }">
    <div>
      <el-input
        size="small"
        clearable
        placeholder="请输入应用名称"
        class="!w-200px mr-10px"
        v-model="keyword"
      />
      <el-button size="small" type="primary" @click="searchList">搜索</el-button>
    </div>
    <el-table
      height="calc(100% - 57px)"
      class="mt-20px"
      border
      stripe
      :data="tableData"
      v-loading="tableLoading"
    >
      <el-table-column type="selection" width="60" align="center"></el-table-column>
      <el-table-column type="index" width="60" label="序号"></el-table-column>
      <el-table-column label="应用程序名称" prop="appName"></el-table-column>
      <el-table-column label="账号">
        <template slot-scope="scope">
          <el-input
            size="small"
            placeholder="请输入账号"
            :readonly="!scope.row.isEdit"
            v-model="scope.row.accountValue"
            :show-password="false"
          />
        </template>
      </el-table-column>
      <el-table-column label="密码" prop="creatorUser">
        <template slot-scope="scope">
          <el-input
            type="password"
            size="small"
            placeholder="请输入密码"
            :readonly="!scope.row.isEdit || !scope.row.password"
            v-model="scope.row.pwdValue"
            :show-password="true"
            :ref="`pwd${scope.$index}`"
          />
        </template>
      </el-table-column>
      <el-table-column width="135" label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="readPassword(scope, false)"
            v-if="scope.row.isView"
            >隐藏</el-button
          >
          <el-button
            size="mini"
            @click="readPassword(scope, true)"
            v-else
            >查看</el-button
          >
          <el-button
            size="mini"
            @click="save(scope.row)"
            v-if="scope.row.isEdit"
            >保存</el-button
          >
          <el-button
            size="mini"
            @click="scope.row.isEdit = true"
            v-else
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import { SingleSignOnApi } from '@wiz-api/workbench'
import { loginType } from '../../js/config'

const singleSignOnApi = new SingleSignOnApi()

export default {
  name: 'ssoManagement',
  data() {
    return {
      keyword: '',
      tableData: [],
      tableLoading: false,
    }
  },
  computed: {
    userInfo() {
      return Wiz.AuthHooks.GetUserInfo()
    },
  },
  methods: {
    searchList() {
      this.findList()
    },
    async findList() {
      this.tableData = []
      this.tableLoading = true
      const [err, res] = await singleSignOnApi.getAppssoParams({
        userId: this.userInfo?.profile?.sub,
      })
      this.tableLoading = false
      if (!err) {
        const filterData = _.filter(res, (item) => {
          return item.appName.includes(this.keyword)
        })
        this.tableData = _.map(filterData, (item) => {
          const type = _.find(loginType, { value: item.loginType })
          return {
            ...item,
            isEdit: false,
            isView: false,
            password: type ? type.password || false : false,
          }
        })
      }
    },
    async save(row) {
      if (!row.accountValue) {
        this.$message.warning('请输入账号!')
        return
      }
      if (row.password && !row.pwdValue) {
        this.$message.warning('请输入密码!')
        return
      }
      let apiRequest = [null, null]
      const body = {
        accountValue: row.accountValue,
        pwdValue: row.pwdValue,
        userId: this.userInfo?.profile?.sub,
        appId: row.appId,
      }
      if (row.id === '00000000-0000-0000-0000-000000000000') {
        apiRequest = await singleSignOnApi.addAppssoParams({
          body,
        })
      } else {
        body.id = row.id
        apiRequest = await singleSignOnApi.updateAppssoParams({
          body,
        })
      }
      if (!apiRequest[0]) {
        this.$message.success('保存成功!')
        this.findList()
      }
    },
    readPassword(scope, bol) {
      scope.row.isView = bol
      this.$refs[`pwd${scope.$index}`].passwordVisible = bol
    },
  },
  created() {
    this.findList()
  },
}
</script>

<style lang="scss" scoped></style>
